<template>
  <div class="switplanet">
    <app-header-container>
      SWITPLANET

      <template v-slot:interactiveBlock>
        <div class="text--xs-small text-color-grey">ТЕКУЩИЙ БАЛАНС</div>
        <div class="text--small text--bold">4 000 167,02 ₽</div>
      </template>

      <template v-slot:interactiveControls><v-button size="small">Action</v-button></template>
    </app-header-container>

    <app-actions-container>
      <template v-slot:interactiveBlock>
        <v-button size="small">Action</v-button>
      </template>
    </app-actions-container>

    <app-hero-container>
      <div style="width: 100%; height: 20rem; display: flex; justify-content: center; align-items: center; background-color: #2c3e50; color: #ffffff;">TestContent</div>
    </app-hero-container>

    <app-controls-container>
      <div class="d-flex">
        <v-button size="small" class="ml-auto">Action</v-button>
      </div>
    </app-controls-container>
    <div v-for="(item, index) in 300" :key="index">SWITPLANET!!!</div>
  </div>
</template>

<script>
import vButton from '@/ui/controls/vButton'

import AppHeaderContainer from '@/ui/layout/AppHeaderContainer'
import AppActionsContainer from '@/ui/layout/AppActionsContainer'
import AppControlsContainer from '@/ui/layout/AppControlsContainer'
import AppHeroContainer from '@/ui/layout/AppHeroContainer'

export default {
  components: {
    vButton,

    AppHeaderContainer,
    AppActionsContainer,
    AppControlsContainer,
    AppHeroContainer
  }
}
</script>

<style lang="scss">

</style>
